import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const insuredExpatValidationSchema = () =>
  Yup.object({
    expatInsuredDetails: Yup.object({
      gender: requiredText(),
      dateOfBirth: requiredText(),
      nationality: requiredText(),
      occupationClass: requiredText(),
      profession: requiredText(),
      passportNumber: requiredText()
    })
  });
